import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PreviousIcon from '@material-ui/icons/Restore';
import AlertIcon from '@material-ui/icons/ErrorOutline';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Grid from '@material-ui/core/Grid';
import ContentBox from 'components/CncUI/ContentBox';
import Typography from 'components/CncUI/Typography';

import parseAddress from '../utils/parseAddress';

const useStyles = makeStyles(({ palette }) => ({
  title: {
    color: palette.cncUI.default['-5'],
    '& svg': {
      verticalAlign: 'middle',
    },
  },
  field: {
    color: palette.cncUI.primary.gray['+3'],
  },
  value: {
    marginTop: 4,
  },
  icon: {
    verticalAlign: 'middle',
    cursor: 'pointer',
  },
  divider: {
    border: 'none',
    borderBottom: `1px solid ${palette.cncUI.primary.gray['+8']}`,
  },
  error: {
    color: palette.cncUI.alert.red.dark,
    marginBottom: 4,
    '& svg': {
      fontSize: 14,
    },
  },
  red: {
    color: palette.cncUI.alert.red.primary,
  },
}));

const Attempts = ({ attempt }) => {
  const classes = useStyles();
  const [visible, setVisible] = useState(false);

  const rowValue = (title, value) => (
    <Grid item xs={12}>
      <Typography variant="caption" noMargin className={classes.field}>
        {title}
      </Typography>
      <Typography
        variant="body1"
        size="short"
        noMargin
        className={classes.value}
      >
        {value}
      </Typography>
    </Grid>
  );

  const rowError = (key, title, description) => (
    <Grid item xs={12} key={key}>
      <Typography variant="caption" medium noMargin className={classes.error}>
        <AlertIcon className={classes.icon} /> {title}
      </Typography>
      <Typography variant="body1" size="short" noMargin className={classes.red}>
        {description}
      </Typography>
    </Grid>
  );

  const input = JSON.parse(attempt.input);
  const error = JSON.parse(attempt.error);
  const mask = `***-**-${attempt.taxId.slice(-4)}`;

  return (
    <ContentBox style={{ padding: 24 }}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h6" className={classes.title} noMargin>
            <PreviousIcon /> Your previous attempt
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ marginBottom: 16 }}>
          <Typography variant="body1" size="short" noMargin>
            Here’s a snapshot of your previous attempt for your reference.
          </Typography>
        </Grid>
        {rowValue(
          'Tax-ID or FEIN',
          <>
            {visible ? attempt.taxId : mask}{' '}
            {visible ? (
              <Visibility
                className={classes.icon}
                onClick={() => setVisible(false)}
              />
            ) : (
              <VisibilityOff
                className={classes.icon}
                onClick={() => setVisible(true)}
              />
            )}
          </>,
        )}
        {rowValue('Corporation Name', input.name)}
        {rowValue('Corporation Type', input.type)}
        {rowValue('Corporation Address', parseAddress(input))}
        <Grid item xs={12}>
          <hr className={classes.divider} />
        </Grid>
        {(error.list || []).map((e, i) => rowError(i, e.title, e.description))}
      </Grid>
    </ContentBox>
  );
};

export default Attempts;
